import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { Container } from '@krakentech/coral';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import {
    StyledHeader,
    StyledHeaderLayout,
    StyledMenuButton,
    StyledMiddleSection,
    StyledLogoContainer,
    StyledNavigationMenu,
    StyledNavigationBackground,
    StyledNavigationContent,
    StyledPrimaryLi,
    StyledSecondaryLi,
    StyledNavigationA,
} from './index.styled';
import { menus } from './content';

const Header = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const router = useRouter();

    const currentPath = (path: string) => {
        const sanitisedPath = path.endsWith('/') ? path.slice(0, -1) : path;
        return sanitisedPath === router.pathname ? 'page' : undefined;
    };

    // Ensure navigation is always closed after we navigate to a new page
    useEffect(() => {
        router.events.on('routeChangeStart', () => setIsExpanded(false));
        return () => {
            router.events.off('routeChangeStart', () => setIsExpanded(false));
        };
    });

    return (
        <StyledHeader>
            <Container>
                <StyledHeaderLayout>
                    <div>
                        <StyledMenuButton
                            expanded={isExpanded}
                            aria-expanded={isExpanded}
                            role="button"
                            aria-label="Toggle navigation menu"
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            <FontAwesomeIcon icon={faBars} />
                            {isExpanded ? 'Back' : 'Menu'}
                        </StyledMenuButton>
                        <StyledNavigationMenu
                            expanded={isExpanded}
                            aria-hidden={!isExpanded}
                        >
                            <StyledNavigationBackground />
                            <StyledNavigationContent>
                                <Container theme="none">
                                    <ul aria-label="Primary links">
                                        {menus.mainMenu.map((link) => (
                                            <StyledPrimaryLi key={link.href}>
                                                <Link href={link.href} passHref>
                                                    <StyledNavigationA
                                                        aria-current={currentPath(
                                                            link.href
                                                        )}
                                                    >
                                                        {link.text}
                                                    </StyledNavigationA>
                                                </Link>
                                            </StyledPrimaryLi>
                                        ))}
                                    </ul>
                                    <ul aria-label="Secondary links">
                                        {menus.subMenu.map((link) => (
                                            <StyledSecondaryLi key={link.href}>
                                                <Link href={link.href} passHref>
                                                    <StyledNavigationA
                                                        aria-current={currentPath(
                                                            link.href
                                                        )}
                                                    >
                                                        {link.text}
                                                    </StyledNavigationA>
                                                </Link>
                                            </StyledSecondaryLi>
                                        ))}
                                    </ul>
                                </Container>
                            </StyledNavigationContent>
                        </StyledNavigationMenu>
                    </div>
                    <StyledMiddleSection>
                        <Link href="/">
                            <StyledLogoContainer>
                                {/* eslint-disable-next-line @next/next/no-img-element */}
                                <img
                                    src="/images/tech-zero-white-small.png"
                                    alt="Tech Zero logo"
                                />
                            </StyledLogoContainer>
                        </Link>
                    </StyledMiddleSection>
                </StyledHeaderLayout>
            </Container>
        </StyledHeader>
    );
};

export default Header;
